import { render } from "./PublicHeader.vue?vue&type=template&id=1a0da5ec&scoped=true"
import script from "./PublicHeader.vue?vue&type=script&lang=js"
export * from "./PublicHeader.vue?vue&type=script&lang=js"

import "./PublicHeader.vue?vue&type=style&index=0&id=1a0da5ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0da5ec"]])

export default __exports__